// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/assign-prescriptions/index.css
// module id = 240
// module chunks = 0